// 引入 axios（确保已安装：npm install axios）
import axios from 'axios'
// 引入语言组合式函数（和你组件里用的一致）
import { useLang } from '@/composables/useLang'

// 全局 API 地址配置，后续改这里即可（保留你原有的配置）
const baseConfig = {
  baseUrl: 'https://www.alwayscreativetech.com/api',
  imgUrl: 'https://www.alwayscreativetech.com',
};

// 创建全局统一的 axios 实例
const api = axios.create({
  baseURL: baseConfig.baseUrl, // 复用你原有的 baseUrl
  timeout: 10000, // 超时时间（避免请求卡很久）
  headers: {
    'Content-Type': 'application/json; charset=utf-8' // 统一请求头
  }
})

// -------------------------- 新增：请求拦截器（统一处理通用逻辑） --------------------------
api.interceptors.request.use(
  (config) => {
    // 1. 统一添加语言参数（不用每个组件手动传 lang）
    const { lang } = useLang()
    config.params = {
      lang: lang.value || 'zh-CN', // 默认为中文
      ...config.params // 保留组件手动传的其他参数（优先级更高）
    }

    // 2. 取消重复请求（解决你之前 3 个相同请求的问题）
    // 先移除已存在的相同请求
    if (window.__axiosCancelTokens__) {
      window.__axiosCancelTokens__[config.url + JSON.stringify(config.params)]?.cancel('重复请求，取消上一次')
    } else {
      window.__axiosCancelTokens__ = {}
    }
    // 创建新的取消令牌
    config.cancelToken = new axios.CancelToken((cancel) => {
      window.__axiosCancelTokens__[config.url + JSON.stringify(config.params)] = { cancel }
    })

    return config
  },
  (error) => {
    // 请求错误的通用处理
    return Promise.reject(error)
  }
)

// -------------------------- 新增：响应拦截器（统一处理返回结果） --------------------------
api.interceptors.response.use(
  (response) => {
    // 1. 移除已完成请求的取消令牌
    const config = response.config
    if (window.__axiosCancelTokens__ && window.__axiosCancelTokens__[config.url + JSON.stringify(config.params)]) {
      delete window.__axiosCancelTokens__[config.url + JSON.stringify(config.params)]
    }
    // 2. 直接返回响应数据体（组件里不用再写 res.data）
    return response.data
  },
  (error) => {
    // 1. 忽略取消请求的错误（避免控制台报错）
    if (axios.isCancel(error)) {
      console.log('请求已取消：', error.message)
      return Promise.reject(error)
    }

    // 2. 统一错误提示（不用每个组件都写 alert）
    let errorMsg = '接口请求失败'
    if (error.message.includes('timeout')) {
      errorMsg = '请求超时，请稍后重试'
    } else if (error.response) {
      // 后端返回的错误（404/500等）
      errorMsg = `请求错误 [${error.response.status}]：${error.response.data?.msg || '未知错误'}`
    } else if (error.request) {
      // 网络错误（连不上服务器）
      errorMsg = '网络异常，请检查网络连接'
    }
    alert(errorMsg)

    // 3. 移除错误请求的取消令牌
    if (error.config && window.__axiosCancelTokens__ && window.__axiosCancelTokens__[error.config.url + JSON.stringify(error.config.params)]) {
      delete window.__axiosCancelTokens__[error.config.url + JSON.stringify(error.config.params)]
    }

    return Promise.reject(error)
  }
)

// 导出：既保留你原有的 baseUrl 配置（兼容旧代码），又导出封装好的 axios 实例
export default {
  ...baseConfig, // 保留原有 baseUrl 配置
  api // 新增封装好的 axios 实例
}